import { Provider } from 'react-redux';
import createStore from './store';

const wrapWithProvider = ({ element }) => {
  const store = createStore();

  return (
    <Provider store={store}>
      {element}
    </Provider>
  );
};

export default wrapWithProvider;
